import { create } from '@bufbuild/protobuf';
import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import { CustomizationChangeRequestSchema } from '../../../pb/requests/v1/customization_change_request_pb';
import { CustomizationChangeResponseSchema } from '../../../pb/responses/v1/customization_change_response_pb';

export const toggleDeliveryCustomizationMutation = async (active: boolean) => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient
        .postRequest(
            CustomizationChangeRequestSchema,
            CustomizationChangeResponseSchema,
            '/api/v1/customization/delivery',
            create(CustomizationChangeRequestSchema, {
                active: active,
                forceCreate: true,
            })
        )
        .then((res) => res);
};
